

export const removeMenuStyles = () => {
    document
        .querySelectorAll('.js-gold-menu.is-clicked')
        .forEach((el) => el.classList.remove('is-clicked'));
}